import { render, staticRenderFns } from "./StepTreeDoc.vue?vue&type=template&id=4ccf2256&scoped=true"
import script from "./StepTreeDoc.vue?vue&type=script&lang=ts"
export * from "./StepTreeDoc.vue?vue&type=script&lang=ts"
import style0 from "./StepTreeDoc.vue?vue&type=style&index=0&id=4ccf2256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf2256",
  null
  
)

export default component.exports